module.exports = __webpack_public_path__ + "static/img/index-pro-电话回访.8efdb15f.png";